
import React from 'react';

export const DealsSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Deals and Offers
          </h2>
          <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            The Best Cruise Deals and Offers From our Partners. Your perfect holiday starts with the World of Cruising. Each issue brings you destination inspiration and the travel tips you have been looking for to book your dream holiday.
          </p>
        </div>

        <div
          className="relative h-96 bg-cover bg-center bg-no-repeat rounded-lg overflow-hidden shadow-xl"
          style={{
            backgroundImage: `url('/images/cruises-explore.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-black/30"></div>
        </div>
      </div>
    </section>
  );
};
